/** Business-hour schedule helpers (11:00–17:00 IST, 15-min steps). */

export const SCHEDULE_START_HOUR = 11;
export const SCHEDULE_END_HOUR = 17;
export const SCHEDULE_INTERVAL_MINUTES = 15;
export const SCHEDULE_TZ_OFFSET = '+05:30';

export function buildScheduleTimeSlots() {
  const slots = [];
  for (let hour = SCHEDULE_START_HOUR; hour <= SCHEDULE_END_HOUR; hour += 1) {
    for (let minute = 0; minute < 60; minute += SCHEDULE_INTERVAL_MINUTES) {
      if (hour === SCHEDULE_END_HOUR && minute > 0) break;
      slots.push(
        `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
      );
    }
  }
  return slots;
}

export function buildScheduleDateOptions(daysAhead = 90) {
  const out = [];
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  for (let i = 0; i < daysAhead; i += 1) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    out.push(`${y}-${m}-${day}`);
  }
  return out;
}

/** Build ISO string for API from YYYY-MM-DD + HH:mm in IST. */
export function toScheduledAtIso(dateYmd, timeHm) {
  return new Date(`${dateYmd}T${timeHm}:00${SCHEDULE_TZ_OFFSET}`).toISOString();
}

export function defaultScheduleFromSuggestion(suggestion) {
  if (!suggestion) {
    const dates = buildScheduleDateOptions(1);
    return {
      date: dates[0],
      time: '11:00',
      iso: toScheduledAtIso(dates[0], '11:00')
    };
  }
  return {
    date: suggestion.suggestedDate,
    time: suggestion.suggestedTime,
    iso: suggestion.suggestedAt
  };
}
